import * as React from "react";

import { BaseComponent } from "./BaseComponent";

export abstract class SimpleComponent<TModel> extends BaseComponent<TModel, TModel> {
    protected constructor(props: TModel) {
        super(props);
    }
}



// WEBPACK FOOTER //
// ./Scripts/React/Component/SimpleComponent.tsx